import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';

var genProListStyle = function genProListStyle(token) {
  var _formOption, _search, _token$componentCls2, _ref;

  return _ref = {}, _defineProperty(_ref, token.componentCls, (_token$componentCls2 = {
    zIndex: 1,
    '&:not(:root):fullscreen': {
      minHeight: '100vh',
      overflow: 'auto',
      background: token.colorBgContainer
    },
    '&-extra': {
      marginBlockEnd: 16
    },
    '&-polling': _defineProperty({}, "".concat(token.componentCls, "-list-toolbar-setting-item"), {
      '.anticon.anticon-reload': {
        transform: 'rotate(0deg)',
        animation: 'turn 1s linear infinite'
      }
    }),
    'td${token.antCls}-table-cell': {
      '>a': {
        fontSize: token.fontSize
      }
    }
  }, _defineProperty(_token$componentCls2, "".concat(token.antCls, "-table").concat(token.antCls, "-table-tbody").concat(token.antCls, "-table-wrapper:only-child").concat(token.antCls, "-table"), {
    marginBlock: 0,
    marginInline: 0
  }), _defineProperty(_token$componentCls2, "".concat(token.antCls, "-table").concat(token.antCls, "-table-middle ").concat(token.componentCls), {
    marginBlock: -12,
    marginInline: -8
  }), _defineProperty(_token$componentCls2, '& &-search', (_search = {
    marginBlockEnd: '16px',
    background: token.colorBgContainer,
    '&-ghost': {
      background: 'transparent'
    }
  }, _defineProperty(_search, "&".concat(token.componentCls, "-form"), {
    marginBlock: 0,
    marginInline: 0,
    paddingBlock: 0,
    paddingInline: 16,
    overflow: 'unset'
  }), _defineProperty(_search, '&-light-filter', {
    marginBlockEnd: 0,
    paddingBlock: 0,
    paddingInline: 8
  }), _defineProperty(_search, '&-form-option', (_formOption = {}, _defineProperty(_formOption, "".concat(token.antCls, "-form-item"), {}), _defineProperty(_formOption, "".concat(token.antCls, "-form-item-label"), {}), _defineProperty(_formOption, "".concat(token.antCls, "-form-item-control-input"), {}), _formOption)), _defineProperty(_search, '@media (max-width: 575px)', _defineProperty({}, token.componentCls, _defineProperty({
    height: 'auto !important',
    paddingBlockEnd: '24px'
  }, "".concat(token.antCls, "-form-item-label"), {
    minWidth: '80px',
    textAlign: 'start'
  }))), _search)), _defineProperty(_token$componentCls2, '&-toolbar', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '64px',
    paddingInline: 24,
    paddingBlock: 0,
    '&-option': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    '&-title': {
      flex: '1',
      color: token.colorTextLabel,
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      opacity: '0.85'
    }
  }), _token$componentCls2)), _defineProperty(_ref, '@keyframes turn', {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '25%': {
      transform: 'rotate(90deg)'
    },
    '50%': {
      transform: 'rotate(180deg)'
    },
    '75%': {
      transform: 'rotate(270deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }), _defineProperty(_ref, "@media (max-width: ".concat(token.screenXS, ")"), _defineProperty({}, token.componentCls, {
    '.ant-table': {
      width: '100%',
      overflowX: 'auto',
      '&-thead > tr,&-tbody > tr': {
        '> th,> td': {
          whiteSpace: 'pre',
          '>span': {
            display: 'block'
          }
        }
      }
    }
  })), _defineProperty(_ref, '@media (max-width: 575px)', _defineProperty({}, "".concat(token.componentCls, "-toolbar"), {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    height: 'auto',
    marginBlockEnd: '16px',
    marginInlineStart: '16px',
    paddingBlock: 8,
    paddingInline: 8,
    paddingBlockStart: '16px',
    lineHeight: 'normal',
    '&-title': {
      marginBlockEnd: 16
    },
    '&-option': {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    },
    '&-default-option': {
      display: 'flex',
      flex: '1',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  })), _ref;
};

export function useStyle(prefixCls) {
  return useAntdStyle('ProTable', function (token) {
    var proListToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });

    return [genProListStyle(proListToken)];
  });
}